export default {
    title: "Confirmación de entrega",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Gracias",
        message: "Gracias por tu respuesta."
    },
    status: {
        yes: "Verifique los productos marcados a continuación para confirmar la entrega y desmarque los que no haya recibido. Luego, haga clic en &quot;Enviar&quot; para confirmar.",
        no: "Verifique que no haya recibido ninguno de los productos a continuación. Si recibió alguno, marque la casilla junto a &quot;Producto(s) recibido(s)&quot; y haga clic en &quot;Enviar&quot; para confirmar."
    },
    model: {
        checked: {
            label: "Recibió"
        }
    },
    button: {
        submit: {
            cta: "Entregar",
            processing: "Sumisión"
        }
    }
}